import { Box, Button, Divider, MenuItem, Select, Typography, Zoom } from "@mui/material";
import { useSnackbar } from "notistack";
import { useState } from "react";
import useAuth from "src/hooks/useAuth";
import Canvas from "./Canvas";
import axios from 'axios';

export default function ConsentimientoInformadoInsert() {
    const [firma, setFirma] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [acepta, setAcepta] = useState({
        aceptaPublicidad: {
            value: '',
            error: false,
            errorText: ''
        },
        aceptaEncuesta: {
            value: '',
            error: false,
            errorText: ''
        },
        aceptaTransDatosTerceros: {
            value: '',
            error: false,
            errorText: ''
        }
    })
    const handleChange = (event) => {
        const { name, value } = event.target;

        setAcepta((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: false, // Resetear el error al cambiar el valor
                errorText: '' // Resetear el mensaje de error
            }
        }));
    };
    const { user } = useAuth()

    let datos = [
        { id: '1', name: 'SI' },
        { id: '0', name: 'NO' }
    ]

    const handleGuardar = async () => {
        let aceptaEncuesta = acepta.aceptaEncuesta
        let aceptaPublicidad = acepta.aceptaPublicidad
        let aceptaTransDatosTerceros = acepta.aceptaTransDatosTerceros
        let errores = []
        if (aceptaEncuesta.value.length === 0) {
            errores.push('Debe seleccionar un valor, en el primer selector')
        }
        if (aceptaPublicidad.value.length === 0) {
            errores.push('Debe seleccionar un valor, en el segundo selector')
        }
        if (aceptaTransDatosTerceros.value.length === 0) {
            errores.push('Debe seleccionar un valor, en el tercer selector')
        }
        if (errores.length > 0) {
            errores.map(x => enqueueSnackbar(x, {
                variant: 'error',
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                TransitionComponent: Zoom,
                autoHideDuration: 2000

            }))
        }
        else {
            try {
                const response = await axios.post(`https://apis.vesaliohce.com.pe/clinica-new/datosPersonalesInsert`, {
                    numeroIdentidad: user.datos.numero_documento,
                    aceptaPublicidad: parseInt(aceptaPublicidad.value),
                    aceptaEncuesta: parseInt(aceptaEncuesta.value),
                    aceptaTransDatosTerceros: parseInt(aceptaTransDatosTerceros.value),
                    pacienteNombre: `${user.datos.ape_paterno} ${user.datos.ape_materno} ${user.datos.nombres}`,
                    firmaB64: firma
                });
                if (response.status === 200) {
                    window.location.reload()
                }
            } catch (e) {
                enqueueSnackbar('Ocurrio un error en nuestro servidores, intentelo mas tarde', {
                    variant: 'error',
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    },
                    TransitionComponent: Zoom,
                    autoHideDuration: 2000

                })
            }
        }



    }

    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h5" sx={{ fontSize: "12px" }}>
                    Remitirle información comercial, publicidad e información en general de los servicios que ofrece VESALIO S.A., a través del teléfono fijo, celular y/o dirección de correo electrónico.
                </Typography>
                <Select
                    size="small"
                    value={acepta.aceptaPublicidad.value}
                    name={"aceptaPublicidad"}
                    onChange={handleChange}
                    sx={{ width: "80px" }}
                >
                    {datos.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", gap: 2, mt: 1, mb: .5, justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h5" sx={{ fontSize: "12px" }}>
                    Realizarle encuestas de satisfacción acerca de los servicios prestados.

                </Typography>
                <Select
                    size="small"
                    value={acepta.aceptaEncuesta.value}
                    name={"aceptaEncuesta"}
                    onChange={handleChange}
                    sx={{ width: "80px" }}
                >
                    {datos.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            <Divider />
            <Box sx={{ display: "flex", gap: 2, mt: 1, justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h5" sx={{ fontSize: "12px" }}>
                    Transferir sus Datos Personales a Empresas del Grupo Empresarial (CENTRO MEDICO VESALIO SAC) para brindar servicios complementarios de la relación como Paciente.
                </Typography>
                <Select
                    size="small"
                    value={acepta.aceptaTransDatosTerceros.value}
                    name={"aceptaTransDatosTerceros"}
                    onChange={handleChange}
                    sx={{ width: "80px" }}
                >
                    {datos.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Typography sx={{ fontSize: "12px", color: "blue" }}>FIRMA</Typography>
            {
                firma === null && <Canvas setFirma={setFirma} firma={firma} />
            }
            {
                firma !== null && <>
                    <img src={firma} alt="firma paciente" />
                    <Button
                        fullWidth
                        sx={{ mb: 1 }}
                        variant="outlined"
                        onClick={() => setFirma(null)}
                        color="error">
                        Restaurar firma
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleGuardar}
                    >
                        Guardar
                    </Button>
                </>
            }
        </Box>
    )
}
